import React, {Component} from 'react';
import moment from "moment";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {getPayslips} from "./store/actions";
import {Button, InputGroup, NonIdealState, Spinner} from "@blueprintjs/core";
import {CSVLink} from "react-csv";
import Icon from "../../../../components/icon";
import {AutoSizer, Column, Table} from "react-virtualized";
import styled from "styled-components";

const StyledList = styled.div`
  height: 100%;
  width: 100%;
  padding: 8px 16px;
`;

const FUSE_OPTIONS = {
  threshold: 0.5,
  maxPatternLength: 32,
  minMatchCharLength: 2,
  keys: [
    {name: 'date', weight: 0.4},
    {name: 'gross', weight: 0.2},
    {name: 'net', weight: 0.2},
    {name: 'currency_id', weight: 0.1},
  ]
};

const EXCEL_HEADERS = [
  { label: 'Period', key: 'date' },
  { label: 'Gross Taxable Pay', key: 'gross' },
  { label: 'Net Payment', key: 'net' },
  { label: 'Currency', key: 'currency_id' },
];

class Payslips extends Component {

  state = {
    records: [],
  }

  componentDidMount() {
    this.props.getPayslips();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    let formatedRecords = [];

    console.log(nextProps.records);

    nextProps.records.map(record => {
      record = {
        ...record,
        period: moment(record.date).isValid() ? moment(record.date).format('MM/YYYY') : '',
        gross: record.gross_pay ? record.gross_pay.toFixed(2) : parseInt('0').toFixed(2),
        net: record.net_payment ? record.net_payment.toFixed(2) : parseInt('0').toFixed(2),
        net_payment: record.net_payment ? record.net_payment.toFixed(2) : parseInt('0').toFixed(2),
        currency_id: record.currency_id ? record.currency_id : parseInt('0'),
      };
      return formatedRecords.push(record);
    });

    this.setState({
      records: formatedRecords
    });
  }

  viewFile (payslipId) {
    const { _id } = this.props.match.params;
    const url = `${process.env.REACT_APP_API_URL}/payslips/get-file/${payslipId}?auth=${window.localStorage.getItem('ammotio-token')}&session=${window.localStorage.getItem('ammotio-session')}`;
    window.open(url, "_blank");
  }

  render() {
    const { loading } = this.props;
    const { records } = this.state;

    return (
      <div className="right">
        {loading ? (
          <Spinner className="mt50" />
        ) : (
          <React.Fragment>
            <div className="tools">
              <div></div>
              <div className="flex">
                {records.length > 0 &&
                <CSVLink
                  headers={EXCEL_HEADERS}
                  data={records}
                  filename={"sales_invoices.csv"}
                  className="mr5"
                  target="_blank"
                >
                  <Icon icon="csv" size={38}/>
                </CSVLink>
                }
                <InputGroup
                  leftIcon="search"
                  onChange={(e) => {
                    this.setState({
                      search: e.currentTarget.value
                    })
                  }}
                  name="vat_number"
                  id="vat_number"
                  large
                  placeholder="Search"
                />
              </div>
            </div>
            {records.length > 0 ? (
              <StyledList>
                <AutoSizer>
                  {({width, height}) => (
                    <Table
                      ref="Table"
                      headerHeight={30}
                      noRowsRenderer={this._noRowsRenderer}
                      overscanRowCount={10}
                      rowClassName={this._rowClassName}
                      rowHeight={30}
                      rowCount={records.length}
                      rowGetter={({ index }) => records[index]}
                      height={height}
                      onRowClick={(event) => console.log(event.rowData)}
                      width={width}>
                      <Column
                        label="Period"
                        dataKey="period"
                        width={width * 0.1}
                      />
                      <Column
                        width={width * 0.1}
                        disableSort
                        label="Gross Taxable Pay"
                        dataKey="gross"
                        flexGrow={1}
                      />
                      <Column
                        width={width * 0.1}
                        disableSort
                        label="Net Payment"
                        dataKey="net"
                        flexGrow={1}
                      />
                      <Column
                        width={width * 0.1}
                        disableSort
                        style={{textAlign: 'center'}}
                        label=""
                        dataKey="id"
                        cellRenderer={({cellData}) => (<Button onClick={() => {this.viewFile(cellData)}} small>View</Button>)}
                      />
                    </Table>
                  )}
                </AutoSizer>
              </StyledList>
            ) : (
              <NonIdealState
                icon="search"
                title="No payslips found"
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

function matchDispatchToProps(dispatch){
  return bindActionCreators({
    getPayslips
  }, dispatch);
}

function mapStateToProps(state){
  return {
    loading: state.payslips.loading,
    records: state.payslips.records,
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(Payslips);
